module.exports = __webpack_public_path__ + "img/slider_3_srb.968b568a.jpg";